import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface CabinetsProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Cabinets: React.FC<CabinetsProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [cabinets, setCabinets] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Interior Features']?.['Cabinets'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Interior Features': { ...s.values?.['Interior Features'], Cabinets: v } } })
    );
    const label = 'Cabinets';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={cabinets}
                />
            ) : (
                <TextBox
                    value={cabinets ?? ''}
                    onChange={(value) => setCabinets(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
